function validateParameter(par) {
  return par && Number.isInteger(Number(par)) && Number(par) > 0;
}

export { validateParameter };
